import { render, staticRenderFns } from "./ModalProcessedWorkOrders.vue?vue&type=template&id=2998ff18&scoped=true&"
import script from "./ModalProcessedWorkOrders.vue?vue&type=script&lang=js&"
export * from "./ModalProcessedWorkOrders.vue?vue&type=script&lang=js&"
import style0 from "./ModalProcessedWorkOrders.vue?vue&type=style&index=0&id=2998ff18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2998ff18",
  null
  
)

export default component.exports